import gsap from "gsap";
import DefaultBlock from "/scripts/default/block";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";

gsap.registerPlugin(ScrollTrigger, ScrambleTextPlugin);

export default class TextScramble extends DefaultBlock {
	init() {
		this.state = {};

		this.DOM = {
			text: this.block.querySelector("#scramble-text-original"),
			cursor: this.block.querySelector("#scramble-cursor"),
		};

		this.createAnimation();
	}

	createAnimation() {
		gsap.set(this.block, { autoAlpha: 1 });

		watchPreferredMotion(() => {
			gsap.set(this.DOM.text, {
				opacity: 0,
			});

			const tl = gsap.timeline({
				id: "text-scramble",
				defaults: { ease: "none" },
				scrollTrigger: {
					trigger: this.DOM.text,
					start: "top 60%",
				},
			});

			const cursorTl = gsap.timeline({ repeat: -1 });

			cursorTl
				.to(this.DOM.cursor, {
					opacity: 0,
					duration: 0.5,
					ease: "none",
					delay: 0.2,
				})
				.to(this.DOM.cursor, {
					opacity: 1,
					duration: 0.5,
					ease: "none",
					delay: 0.2,
				});

			tl.to("#scramble-text-1", {
				scrambleText: {
					text: "Mix it up with ScrambleText.",
					chars: "lowerCase",
				},
				duration: 2,
			})
				.to("#scramble-text-2", {
					scrambleText: {
						text: "Animate using characters",
						chars: "XO",
						speed: 0.4,
					},
					duration: 2,
				})
				.to("#scramble-text-3", {
					scrambleText: { text: " numbers,", chars: "0123456789" },
					duration: 2,
				})
				.to("#scramble-text-4", {
					scrambleText: { text: "UPPERCASE", chars: "upperCase", speed: 0.3 },
					duration: 1,
				})
				.to("#scramble-text-5", {
					scrambleText: {
						text: "or lowercase.",
						chars: "lowerCase",
						speed: 0.3,
					},
					duration: 1.5,
				})
				.add(cursorTl);

			// GSDevTools.create();
		});
	}
}
